import { render, staticRenderFns } from "./PlanejamentoContratoFormOrigemContrato.vue?vue&type=template&id=09b25f6a"
import script from "./PlanejamentoContratoFormOrigemContrato.vue?vue&type=script&lang=js"
export * from "./PlanejamentoContratoFormOrigemContrato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports